import React from 'react';
import './styles.scss';

const ServerError = () => {
  return (
    <div styleName="wrapper" data-testid="server-error">
      <div styleName="instruction">
        {'An error has occurred. Please contact support. Return to our '}
        <a styleName="link" href="/" title="Pear Therapeutics">
          home page
        </a>
        .
      </div>
      <div styleName="pear-down" />
    </div>
  );
};

export default ServerError;
